import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";

export interface ITranslationUploadError {
  validationIssues?: ITranslationUploadValidationIssue[];
  text?: string;
}

export interface ITranslationUploadValidationIssue {
  uniqueId: string;
  messageId: string;
  messageTranslation: string;
  locale: string;
  industry: string;
  validationIssue: IValidationIssue;
}

export interface ITranslationUploadState {
  uploadProcessing: boolean;
  uploadCompleted: boolean;
  error?: ITranslationUploadError;
  notifications: INotification[];
  progress: number;
}

export const getInitialTranslationUploadState = (): ITranslationUploadState => ({
  uploadProcessing: false,
  uploadCompleted: false,
  notifications: [],
  progress: 0
});
